/*@flow*/
import cartoTile from 'lib/leaflet-plugins/CartoTile';
import type { DeckPropsT } from '../types';
import { useEffect, useState } from 'react';
import useLayer from '../useLayer';

type OptionsT = {|
  id: any,
  userName: string,
  sql: string,
  cartocss: string,
  interactivity: string,
|};

type ElementT = Leaflet$TileLayer & { loadLayers: (o: OptionsT) => void };

export default (props: DeckPropsT<OptionsT>) => {
  const [element, setElement] = useState();
  const { options } = props;

  // Setup and configure plugin.
  useEffect(() => {
    const opts = {
      userName: 'swc28',
      maxZoom: 22,
      ...options,
    };
    const el: ElementT = cartoTile(opts);
    setElement(() => el);
  }, []);

  // Add/Remove layer.
  useLayer<OptionsT>(props, element);

  // Re-load Carto layer when the options change.
  useEffect(() => {
    if (!element) return;
    element.loadLayers(options);
  }, [options, element]);
};
